import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=77121a6c"
import script from "./DocumentsTab.vue?vue&type=script&lang=js"
export * from "./DocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTab.vue?vue&type=style&index=0&id=77121a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports